import { Outlet } from 'react-router-dom';

import { ChosenSimsSection } from './ChosenSimsSection';
import { SimForm } from './SimForm';

export const mobileRoutes = {
  path: '',
  element: <Outlet />,
  children: [
    {
      path: '',
      element: <ChosenSimsSection />,
    },
    {
      path: 'sim/:simId/settings',
      element: <SimForm />,
    },
    {
      path: 'sim/add',
      element: <SimForm />,
    },
  ],
};
